import { Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { StepDurationUnits, StepBasicLayout, StepElements, OfferIntents } from '../../../_models';
import { FormArray, FormGroup } from '@angular/forms';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { AlertService, StepEmulatorService } from '../../../_services';
import { FormControlStatus } from '../../../_forms';
import { HoldOffAbstractComponent } from '../step-discount-settings/hold-off-abstract.component';
import { MatExpansionPanel } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'step-time-delay',
  templateUrl: './step-time-delay.component.html',
  styleUrls: ['./step-time-delay.component.scss'],
  animations: [
    trigger('fadeInOut', [
      state('void', style({ opacity: 0 })),
      transition(':enter', [animate('500ms ease-in', style({ opacity: 1 }))]),
      transition(':leave', [animate('300ms ease-out', style({ opacity: 0 }))]),
    ]),
  ],
  encapsulation: ViewEncapsulation.None,
})
export class StepTimeDelayComponent extends HoldOffAbstractComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() layout: StepBasicLayout;
  @Input() enableFormErrors: boolean;
  @Input() isNew: boolean;
  @Input() templateId: string;
  stepElements = StepElements;
  stepDurationUnits = StepDurationUnits;
  unit: StepDurationUnits = StepDurationUnits.Days;
  duration: number;
  actions: FormGroup;
  offerIntent: OfferIntents;
  @ViewChild('panel', { static: false }) panel: MatExpansionPanel;

  constructor(
    protected stepEmulatorService: StepEmulatorService,
    protected router: Router,
    protected location: Location,
    protected alertService: AlertService,
    protected route: ActivatedRoute
  ) {
    super(alertService, router, location);
    this.route.params.subscribe((params) => {
      this.offerIntent = params['offer_intent'] ? parseInt(params['offer_intent']) : null;
    });
  }

  ngOnInit() {
    this.setTitleAndSubtitle();

    const nextBillDateDelayControl = this.form.get(['inputs', 0, 'actions', 0, 'next_bill_date_delay']);
    if (nextBillDateDelayControl) {
      this.duration = nextBillDateDelayControl.value;
    }

    this.actions = this.form.get(['inputs', 0, 'actions', 0]) as FormGroup;
    super.ngOnInit();
  }

  updateTimeDelay() {
    (this.form.get('inputs') as FormArray)
      .at(0)
      .get('actions')
      .get('0')
      .patchValue({
        next_bill_date_delay:
          +this.unit === StepDurationUnits.Weeks ? Number(this.duration * 7) : Number(this.duration),
      });
  }

  toggleElement(element: StepElements) {
    this.stepEmulatorService.toggleElement(element);
  }

  isElementVisible(element: StepElements): boolean {
    return this.stepEmulatorService.isElementVisible(element);
  }

  get settingsInvalidity() {
    return this.enableFormErrors && this.actions.status === FormControlStatus.Invalid;
  }

  get holdOffInvalidity() {
    return this.enableFormErrors && this.actions.controls.holdoff_delay.status === FormControlStatus.Invalid;
  }

  get timeDelayInvalidity() {
    return this.enableFormErrors && this.actions.controls.next_bill_date_delay.status === FormControlStatus.Invalid;
  }

  private setTitleAndSubtitle(): void {
    // Extend Trial keeps its own layout title/subtitle; only Skip/Pause are overridden
    // here (Skip reuses the Pause layout).
    if (this.offerIntent !== OfferIntents.ExtendTrial) {
      const isSkip = this.offerIntent === OfferIntents.SkipSubscription;

      this.layout.title = `${isSkip ? 'Skip' : 'Pause'} Settings`;
      this.layout.subtitle = `Define how long the customer’s subscription will be ${
        isSkip ? 'skipped' : 'paused'
      } if they accept this offer.`;
    }
  }
}
